export { useDatabaseTranslation } from './use-database-translation';
